import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles((theme) => ({
  countdown: {
    marginTop: theme.spacing(2.5),
    textAlign: 'center',
    fontWeight: 600,
    // marginTop 0 if width between 900 and 500px
    [theme.breakpoints.between('xs', 'sm')]: {
      marginTop: theme.spacing(1.25)
    }
  }
}));
